import {
  Field as ChakraField,
  type FieldRootProps,
  type HTMLChakraProps
} from "@chakra-ui/react";
import { forwardRef, type ReactNode } from "react";

import { asSlotComponent } from "../internal/v3-slot";

const ChakraFieldLabel = asSlotComponent(ChakraField.Label);
const ChakraFieldRequiredIndicator = asSlotComponent(
  ChakraField.RequiredIndicator
);

// Chakra's FieldLabelProps recipe type omits htmlFor/as/style props that the
// label legitimately takes, so type off the label element props instead.
const FieldLabel = forwardRef<
  HTMLLabelElement,
  HTMLChakraProps<"label"> & {
    children?: ReactNode;
    hideRequiredIndicator?: boolean;
  }
>(function FieldLabel({ children, hideRequiredIndicator, ...rest }, ref) {
  return (
    <ChakraFieldLabel ref={ref} {...rest}>
      {children}
      {!hideRequiredIndicator && <ChakraFieldRequiredIndicator />}
    </ChakraFieldLabel>
  );
});

const FieldRoot = forwardRef<HTMLDivElement, FieldRootProps>(
  function FieldRoot(props, ref) {
    return (
      <ChakraField.Root ref={ref} gap="0" alignItems="stretch" {...props} />
    );
  }
);

export const Field = {
  Root: FieldRoot,
  Label: FieldLabel,
  HelperText: asSlotComponent(ChakraField.HelperText),
  ErrorText: asSlotComponent(ChakraField.ErrorText),
  ErrorIcon: asSlotComponent(ChakraField.ErrorIcon),
  RequiredIndicator: ChakraFieldRequiredIndicator
};

export type {
  FieldRootProps,
  FieldLabelProps,
  FieldHelperTextProps,
  FieldErrorTextProps,
  FieldErrorIconProps
} from "@chakra-ui/react";
